import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import DPServices from "@dp/services";
import { makeObservable, observable, reaction, runInAction } from "mobx";
import { CartModel } from ".";
import Base from "./Base";
import OrderConfirmationModel from "./models/OrderConfirmationModel";
import BreadSticksModel from "./models/BreadSticksModel";
import { DecodedOrderType, PlatformType } from "@dp/common";
import moment from "moment";
var OrderConfirmation = (_class = /*#__PURE__*/function (_Base) {
  _inherits(OrderConfirmation, _Base);

  var _super = _createSuper(OrderConfirmation);

  function OrderConfirmation(rootStore) {
    var _this;

    _classCallCheck(this, OrderConfirmation);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "orderConfirmationModel", null);

    _defineProperty(_assertThisInitialized(_this), "breadSticksModel", null);

    _defineProperty(_assertThisInitialized(_this), "cartModel", null);

    _initializerDefineProperty(_assertThisInitialized(_this), "_restuarantDetails", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_sessionDetails", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _this.rootStore = rootStore;
    var platformUtil = _this.rootStore.platformUtil;
    _this.orderConfirmationModel = new OrderConfirmationModel(platformUtil);
    _this.cartModel = new CartModel(platformUtil);
    _this.breadSticksModel = new BreadSticksModel();
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OrderConfirmation, [{
    key: "_processSessionDetails",
    value: function _processSessionDetails(session) {
      var _this2 = this;

      this.cartModel.setSessionDetails(session);
      this.orderConfirmationModel.setSessionDetails(session);
      runInAction(function () {
        _this2._sessionDetails = session;
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function () {
      var _processAppAttributes2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appAttributes) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.cartModel.setAppAttributesData(appAttributes);
                this.orderConfirmationModel.setAppAttributes(appAttributes);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _processAppAttributes(_x) {
        return _processAppAttributes2.apply(this, arguments);
      }

      return _processAppAttributes;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$rootStore,
            _this$rootStore$user,
            _this$rootStore2,
            _this$rootStore2$rest,
            _this3 = this;

        var restaurantDetail;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.analyticsModel = (_this$rootStore = this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.analyticsModel;

                this._processSessionDetails(this.rootStore.user.sessionDetails);

                _context2.next = 4;
                return this._processAppAttributes(this.rootStore.common.appAttributes);

              case 4:
                restaurantDetail = (_this$rootStore2 = this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : (_this$rootStore2$rest = _this$rootStore2.restaurant) === null || _this$rootStore2$rest === void 0 ? void 0 : _this$rootStore2$rest.detail;
                runInAction(function () {
                  _this3._restuarantDetails = restaurantDetail;

                  _this3.analyticsModel.setRestaurantDetailData(restaurantDetail);

                  _this3.orderConfirmationModel.setRestaurantDetailData(restaurantDetail);
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", Promise.resolve());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this4 = this; //session-details


      reaction(function () {
        var _this4$rootStore, _this4$rootStore$rest;

        return {
          detail: (_this4$rootStore = _this4.rootStore) === null || _this4$rootStore === void 0 ? void 0 : (_this4$rootStore$rest = _this4$rootStore.restaurant) === null || _this4$rootStore$rest === void 0 ? void 0 : _this4$rootStore$rest.detail
        };
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this4._restuarantDetails = data === null || data === void 0 ? void 0 : data.detail;

                  _this4.orderConfirmationModel.setRestaurantDetailData(data === null || data === void 0 ? void 0 : data.detail);

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
      reaction(function () {
        return {
          sessionDetails: _this4.rootStore.user.sessionDetails
        };
      }, function (data) {
        _this4._processSessionDetails(data.sessionDetails);
      });
    }
  }, {
    key: "redirectToMenuPage",
    value: function () {
      var _redirectToMenuPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.rootStore.refreshInProgress = true;

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.rootStore.platformUtil.navigateToRoute("/menu");
                } else this.rootStore.platformUtil.redirectToURL("/menu");

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function redirectToMenuPage() {
        return _redirectToMenuPage.apply(this, arguments);
      }

      return redirectToMenuPage;
    }()
  }, {
    key: "getLastOrderData",
    value: function () {
      var _getLastOrderData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _lastOrder$order, _lastOrder$order$pric;

        var lastOrder, _lastOrder$order2, _lastOrder$order3, _this$rootStore3, _this$rootStore3$user, _lastOrder$order4, _this$_sessionDetails, _this$_sessionDetails2, _this$_sessionDetails3, _this$_sessionDetails4, _this$_sessionDetails5, _this$_sessionDetails6;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return DPServices.Confirmation.getLastOrder();

              case 2:
                lastOrder = _context7.sent;

                if (!(lastOrder && Object.keys(lastOrder).length > 0 && !!(lastOrder !== null && lastOrder !== void 0 && (_lastOrder$order = lastOrder.order) !== null && _lastOrder$order !== void 0 && (_lastOrder$order$pric = _lastOrder$order.priceInfo) !== null && _lastOrder$order$pric !== void 0 && _lastOrder$order$pric.total))) {
                  _context7.next = 12;
                  break;
                }

                this.orderConfirmationModel.setLastOrderData(lastOrder);
                this.setCartItems(lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order2 = lastOrder.order) === null || _lastOrder$order2 === void 0 ? void 0 : _lastOrder$order2.commerceItems);
                this.breadSticksModel.cartItems = lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order3 = lastOrder.order) === null || _lastOrder$order3 === void 0 ? void 0 : _lastOrder$order3.commerceItems;

                if (!((_this$rootStore3 = this.rootStore) !== null && _this$rootStore3 !== void 0 && (_this$rootStore3$user = _this$rootStore3.user) !== null && _this$rootStore3$user !== void 0 && _this$rootStore3$user.isLoggedIn)) {
                  this.saveOrderDataInLocalStorage();
                }

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP) {
                  this.checkAndSaveCurbsideOrderDataInLocalStorage();
                }

                this.orderConfirmEvent(lastOrder === null || lastOrder === void 0 ? void 0 : (_lastOrder$order4 = lastOrder.order) === null || _lastOrder$order4 === void 0 ? void 0 : _lastOrder$order4.orderId, this === null || this === void 0 ? void 0 : (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.successResponse) === null || _this$_sessionDetails2 === void 0 ? void 0 : (_this$_sessionDetails3 = _this$_sessionDetails2.restaurantDetails) === null || _this$_sessionDetails3 === void 0 ? void 0 : _this$_sessionDetails3.restaurantId, this === null || this === void 0 ? void 0 : (_this$_sessionDetails4 = this._sessionDetails) === null || _this$_sessionDetails4 === void 0 ? void 0 : (_this$_sessionDetails5 = _this$_sessionDetails4.successResponse) === null || _this$_sessionDetails5 === void 0 ? void 0 : (_this$_sessionDetails6 = _this$_sessionDetails5.restaurantDetails) === null || _this$_sessionDetails6 === void 0 ? void 0 : _this$_sessionDetails6.restaurantNumber, lastOrder.order.specialInstruction);
                this.analyticsModel.dispatchPurchase();
                return _context7.abrupt("return");

              case 12:
                this.redirectToMenuPage();

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getLastOrderData() {
        return _getLastOrderData.apply(this, arguments);
      }

      return getLastOrderData;
    }()
  }, {
    key: "setCartItems",
    value: function () {
      var _setCartItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(commerceItems) {
        var cartItems;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                cartItems = this.cartModel.getCartItemsFromCommerceItems(commerceItems);
                this.orderConfirmationModel.setCartItems(cartItems);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setCartItems(_x3) {
        return _setCartItems.apply(this, arguments);
      }

      return setCartItems;
    }()
  }, {
    key: "setJoinEClub",
    value: function () {
      var _setJoinEClub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(email, signupSource) {
        var secondarySubscriptions,
            eClubStep,
            res,
            _this$rootStore4,
            _this$rootStore4$appM,
            _this$rootStore5,
            _this$rootStore5$appM,
            _args9 = arguments;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                secondarySubscriptions = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : [];
                eClubStep = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : "1";
                _context9.next = 4;
                return DPServices.Confirmation.setJoinEClub(email, signupSource, secondarySubscriptions, eClubStep);

              case 4:
                res = _context9.sent;

                if (res !== null && res !== void 0 && res.guestAlreadySubscribed) {
                  (_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$appM = _this$rootStore4.appMessages) === null || _this$rootStore4$appM === void 0 ? void 0 : _this$rootStore4$appM.showError("Error", "You are already subscribed to the eClub.");
                } else {
                  // analytics code
                  this.orderConfirmEClubEvent(secondarySubscriptions, signupSource);
                  (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$appM = _this$rootStore5.appMessages) === null || _this$rootStore5$appM === void 0 ? void 0 : _this$rootStore5$appM.showError("Success", "You have been subscribed to the eClub.");
                }

                return _context9.abrupt("return", res);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setJoinEClub(_x4, _x5) {
        return _setJoinEClub.apply(this, arguments);
      }

      return setJoinEClub;
    }()
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(args) {
        var res, _args$dobYear, _this$_sessionDetails7, _this$_sessionDetails8, _this$_sessionDetails9, _this$_sessionDetails10, _this$_sessionDetails11, _this$_sessionDetails12, _this$rootStore$platf, _this$rootStore6, _this$rootStore6$appM, _res$data;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return DPServices.Confirmation.createAccount(args);

              case 2:
                res = _context10.sent;

                if (res.success) {
                  // analytics code
                  this.accountCreationEvent(null, null, "US", args === null || args === void 0 ? void 0 : (_args$dobYear = args.dobYear) === null || _args$dobYear === void 0 ? void 0 : _args$dobYear.toString(), this === null || this === void 0 ? void 0 : (_this$_sessionDetails7 = this._sessionDetails) === null || _this$_sessionDetails7 === void 0 ? void 0 : (_this$_sessionDetails8 = _this$_sessionDetails7.successResponse) === null || _this$_sessionDetails8 === void 0 ? void 0 : (_this$_sessionDetails9 = _this$_sessionDetails8.restaurantDetails) === null || _this$_sessionDetails9 === void 0 ? void 0 : _this$_sessionDetails9.restaurantId, this === null || this === void 0 ? void 0 : (_this$_sessionDetails10 = this._sessionDetails) === null || _this$_sessionDetails10 === void 0 ? void 0 : (_this$_sessionDetails11 = _this$_sessionDetails10.successResponse) === null || _this$_sessionDetails11 === void 0 ? void 0 : (_this$_sessionDetails12 = _this$_sessionDetails11.restaurantDetails) === null || _this$_sessionDetails12 === void 0 ? void 0 : _this$_sessionDetails12.restaurantNumber);
                  (_this$rootStore$platf = this.rootStore.platformUtil) === null || _this$rootStore$platf === void 0 ? void 0 : _this$rootStore$platf.redirectToURL("/customer-service/recent-activity");
                } else {
                  (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$appM = _this$rootStore6.appMessages) === null || _this$rootStore6$appM === void 0 ? void 0 : _this$rootStore6$appM.showError("Error", "A user already exists with the login ".concat(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.login));
                }

                return _context10.abrupt("return", res);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function createAccount(_x6) {
        return _createAccount.apply(this, arguments);
      }

      return createAccount;
    }()
  }, {
    key: "orderConfirmEClubEvent",
    value: function () {
      var _orderConfirmEClubEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(brands, signupChannel) {
        var brandValForEvents;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (brands && brands.length > 0) {
                  brandValForEvents = brands.map(function (el) {
                    switch (el) {
                      case "general-olive-garden-logo":
                        return "OG";

                      case "general-longhorn-logo":
                        return "LH";

                      case "general-cheddars-logo":
                        return "CSK";

                      case "general-seasons-logo":
                        return "S52";

                      case "general-bahama-breeze-logo":
                        return "BB";

                      case "general-yard-house-logo":
                        return "YH";

                      case "general-eddie-vs-logo":
                        return "EV";

                      case "general-the-capital-grill-logo":
                        return "TCG";

                      case "general-the-capital-burger-logo":
                        return "TCB";

                      default:
                        return el;
                    }
                  });
                  this.analyticsModel.dispatchEClubOrderConfirmation(brandValForEvents, signupChannel);
                }

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function orderConfirmEClubEvent(_x7, _x8) {
        return _orderConfirmEClubEvent.apply(this, arguments);
      }

      return orderConfirmEClubEvent;
    }()
  }, {
    key: "orderConfirmEvent",
    value: function () {
      var _orderConfirmEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(orderId, restId, restNum, specialInstruction) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmation(orderId, restId, restNum, specialInstruction);

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function orderConfirmEvent(_x9, _x10, _x11, _x12) {
        return _orderConfirmEvent.apply(this, arguments);
      }

      return orderConfirmEvent;
    }()
  }, {
    key: "accountCreationEvent",
    value: function () {
      var _accountCreationEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(zipCode, state, country, birthYear, restId, restNum) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.analyticsModel.dispatchOrderConfirmationAccCreat(zipCode, state, country, birthYear, restId, restNum);

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function accountCreationEvent(_x13, _x14, _x15, _x16, _x17, _x18) {
        return _accountCreationEvent.apply(this, arguments);
      }

      return accountCreationEvent;
    }()
  }, {
    key: "processLastOrderObject",
    value: function processLastOrderObject() {
      var _this$rootStore$check, _this$rootStore$check2, _this$rootStore$check3, _this$rootStore$check4, _this$rootStore$check5, _this$rootStore$check6, _this$rootStore$check7, _this$rootStore$check8;

      var lastOrder = this.orderConfirmationModel.lastOrderData;
      var date = new Date();
      var order = {
        shippingGroup: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.shippingGroup,
        orderType: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.orderType,
        specialInstruction: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.specialInstruction,
        orderId: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.orderId,
        payInRestaurant: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.payInRestaurant,
        discount: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.discount,
        subTotalWithoutItemDiscount: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.subTotalWithoutItemDiscount,
        orderVersion: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.orderVersion,
        restaurantId: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.restaurantId,
        giftCardQuantity: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.giftCardQuantity,
        giftCardTotal: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.giftCardTotal,
        pickUpInfo: {
          carColor: (_this$rootStore$check = this.rootStore.checkout) === null || _this$rootStore$check === void 0 ? void 0 : (_this$rootStore$check2 = _this$rootStore$check.pickupInfoModel) === null || _this$rootStore$check2 === void 0 ? void 0 : _this$rootStore$check2.vehicleColor,
          carType: (_this$rootStore$check3 = this.rootStore.checkout) === null || _this$rootStore$check3 === void 0 ? void 0 : (_this$rootStore$check4 = _this$rootStore$check3.pickupInfoModel) === null || _this$rootStore$check4 === void 0 ? void 0 : _this$rootStore$check4.vehicleType,
          "@class": "",
          email: "",
          firstName: "",
          includeSilverware: (_this$rootStore$check5 = this.rootStore.checkout) === null || _this$rootStore$check5 === void 0 ? void 0 : (_this$rootStore$check6 = _this$rootStore$check5.orderInstructionModel) === null || _this$rootStore$check6 === void 0 ? void 0 : _this$rootStore$check6.includeSilverware,
          lastName: "",
          pickUpName: "",
          restaurantId: "",
          timestamp: ""
        },
        couponDiscount: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.couponDiscount,
        priceInfo: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.priceInfo,
        promotionDiscount: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.promotionDiscount,
        totalTipAmount: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.totalTipAmount,
        isCatering: false,
        paymentGroup: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.paymentGroup,
        tippableAmount: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.tippableAmount,
        state: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.state,
        commerceItems: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.commerceItems,
        restaurantAddress: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.restaurantAddress,
        restaurantName: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.restaurantName,
        requestedPickupTime: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.requestedPickupTime,
        deliveryFee: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.deliveryFee,
        paymentDetails: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.paymentDetails
      };
      var recentOrderObj = {
        orderType: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.orderType,
        shippingGroups: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.shippingGroup,
        emailId: (_this$rootStore$check7 = this.rootStore.checkout) === null || _this$rootStore$check7 === void 0 ? void 0 : (_this$rootStore$check8 = _this$rootStore$check7.contactInfoModel) === null || _this$rootStore$check8 === void 0 ? void 0 : _this$rootStore$check8.emailId,
        restaurantId: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.restaurantId,
        submittedDate: {
          time: date.getTime()
        },
        state: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.state,
        id: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.orderId,
        order: order,
        commerceItems: lastOrder === null || lastOrder === void 0 ? void 0 : lastOrder.commerceItems
      };
      return recentOrderObj;
    }
  }, {
    key: "saveOrderDataInLocalStorage",
    value: function () {
      var _saveOrderDataInLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var recentOrderObj, updatedData, storedData, _this$rootStore7, _this$rootStore7$menu, thresholdTimestamp, updatedDataAfterTimeValidation;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                recentOrderObj = this.processLastOrderObject();
                updatedData = [];
                _context14.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("RECENT_ORDER_DETAILS").then(JSON.parse);

              case 4:
                storedData = _context14.sent;

                if (storedData) {
                  updatedData = [].concat(_toConsumableArray(storedData), [recentOrderObj]);
                } else {
                  updatedData = [recentOrderObj];
                }

                _context14.prev = 6;
                thresholdTimestamp = moment().subtract(6, "months").valueOf();
                updatedDataAfterTimeValidation = updatedData.filter(function (_data) {
                  var _data$submittedDate;

                  var orderTimeStamp = _data === null || _data === void 0 ? void 0 : (_data$submittedDate = _data.submittedDate) === null || _data$submittedDate === void 0 ? void 0 : _data$submittedDate.time;
                  return orderTimeStamp > thresholdTimestamp;
                });
                _context14.next = 11;
                return this.rootStore.platformUtil.saveInLocalStorage("RECENT_ORDER_DETAILS", JSON.stringify(updatedDataAfterTimeValidation));

              case 11:
                _context14.next = 13;
                return (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$menu = _this$rootStore7.menuList) === null || _this$rootStore7$menu === void 0 ? void 0 : _this$rootStore7$menu.fetchRecentOrdersFromLocalStorage();

              case 13:
                _context14.next = 18;
                break;

              case 15:
                _context14.prev = 15;
                _context14.t0 = _context14["catch"](6);
                console.log("*** catch", _context14.t0);

              case 18:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[6, 15]]);
      }));

      function saveOrderDataInLocalStorage() {
        return _saveOrderDataInLocalStorage.apply(this, arguments);
      }

      return saveOrderDataInLocalStorage;
    }()
  }, {
    key: "checkAndSaveCurbsideOrderDataInLocalStorage",
    value: function () {
      var _checkAndSaveCurbsideOrderDataInLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this$rootStore$curbs, curbsideDetails, _this$rootStore$curbs2, curbsideOrderData;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return (_this$rootStore$curbs = this.rootStore.curbside) === null || _this$rootStore$curbs === void 0 ? void 0 : _this$rootStore$curbs.checkIfCurbsideEnabled();

              case 3:
                curbsideDetails = _context15.sent;

                if (!curbsideDetails.enabled) {
                  _context15.next = 10;
                  break;
                }

                curbsideOrderData = this.processLastOrderObject();
                _context15.next = 8;
                return this.rootStore.platformUtil.saveInLocalStorage(curbsideDetails.checkReference, JSON.stringify(curbsideOrderData));

              case 8:
                _context15.next = 10;
                return (_this$rootStore$curbs2 = this.rootStore.curbside) === null || _this$rootStore$curbs2 === void 0 ? void 0 : _this$rootStore$curbs2.fetchCurbsideCheckSummary();

              case 10:
                _context15.next = 14;
                break;

              case 12:
                _context15.prev = 12;
                _context15.t0 = _context15["catch"](0);

              case 14:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 12]]);
      }));

      function checkAndSaveCurbsideOrderDataInLocalStorage() {
        return _checkAndSaveCurbsideOrderDataInLocalStorage.apply(this, arguments);
      }

      return checkAndSaveCurbsideOrderDataInLocalStorage;
    }()
  }, {
    key: "shareText",
    get: function get() {
      var shareTextDetails = this.orderConfirmationModel.getShareTextDetails();
      if (shareTextDetails.orderType === DecodedOrderType.CATERING_DELIVERY) return "Your ".concat(this.rootStore.common.appAttributes.concept.conceptCodeDesc, " ").concat(shareTextDetails.orderType, " Order #").concat(shareTextDetails.orderId, " \n\n-from-\n").concat(shareTextDetails.restaurantDetails.restName, ", ").concat(shareTextDetails.restaurantDetails.restAddress, ", ").concat(shareTextDetails.restaurantDetails.addressLineTwo, "\n\nReceiving the Order: ").concat(shareTextDetails.name, "\nTotal Paid: ").concat(shareTextDetails.orderTotal, " \n\nFor car-side pickup, please call the restaurant at ").concat(shareTextDetails.restaurantPhone, " upon arrival.");
      return "Your ".concat(this.rootStore.common.appAttributes.concept.conceptCodeDesc, " ").concat(shareTextDetails.orderType, " Order #").concat(shareTextDetails.orderId, " will be ready:\n\n").concat(shareTextDetails.restaurantDetails.pickupTime, "\n-at-\n").concat(shareTextDetails.restaurantDetails.restName, ", ").concat(shareTextDetails.restaurantDetails.restAddress, ", ").concat(shareTextDetails.restaurantDetails.addressLineTwo, "\n\nPicking up Order: ").concat(shareTextDetails.pickupDetails.pickupByName, "\nTotal Paid: ").concat(shareTextDetails.orderTotal, " \n\nFor car-side pickup, please call the restaurant at ").concat(shareTextDetails.restaurantPhone, " upon arrival.");
    }
  }]);

  return OrderConfirmation;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_restuarantDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class);
export { OrderConfirmation as default };